import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./TocBlock').then(m => ({default: m.TocBlock})),
)

export const tocBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
})
